import { Button, Divider, message, Select } from "antd";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { createComponentStore } from "easy-peasy";
import GeneralCRUDModel, { ACTION_TYPES } from "store/models/general-crud";

export default function FetchSelect({
  api,
  defaultValue,
  type,
  form,
  filter,
  placeholder,
  field,
  onChange,
  optionLabelField,
  optionLabelSeperator = " ",
  excludedOptions,
  disabledOptions,
  labelInValue = false,
  objectInValue = true,
  ...props
}) {
  const useStore = createComponentStore(GeneralCRUDModel(api));
  const [store, actions] = useStore();

  const [data, setData] = useState([]);

  const control = form.control;
  const _excludedOptions = excludedOptions || [];

  useEffect(() => {
    if (props.hasOwnProperty("dependent") && !props.dependent) return;

    actions.fetch({ ...api.params });
  }, [props.dependent]);

  useEffect(() => {
    let _data = null;
    if (store.process === ACTION_TYPES.FETCHED_DATA) {
      if (store.data.hasOwnProperty("content")) {
        _data = store.data.content;
      } else {
        _data = store.data;
      }

      if (filter) {
        _data = _data.filter(
          (f) =>
            (f[filter.dataIndex] ||
              (Array.isArray(filter.dataIndex)
                ? filter.dataIndex.reduce((prev, curr) => prev && prev[curr], f)
                : "")) == filter.value
        );
      }

      let sorterProperty = null;
      if (_data && _data.length > 0) {
        if (_data[0].hasOwnProperty("description")) {
          sorterProperty = "description";
        } else if (_data[0].hasOwnProperty("name")) {
          sorterProperty = "name";
        } else if (_data[0].hasOwnProperty("variantName")) {
          sorterProperty = "variantName";
        }

        if (sorterProperty) {
          _data.sort((a, b) =>
            a[sorterProperty].toUpperCase() > b[sorterProperty].toUpperCase()
              ? 1
              : -1
          );
        }
      }
      setData(_data);
    }
  }, [store]);

  const generateOptionLabel = (d) => {
    if (optionLabelField) {
      let label = "";
      optionLabelField.forEach((i) => {
        if (i.includes(".")) {
          //eğer label daha alt propertiler içerisinde aranıyorsa (compId.name gibi) burası hallediyor
          label =
            label +
            (label.length <= 0 ? "" : optionLabelSeperator) +
            i.split(".").reduce(function (obj, prop) {
              return obj && obj[prop];
            }, d);
        } else {
          label =
            label + (label.length <= 0 ? "" : optionLabelSeperator) + d[i];
        }
      });
      return label;
    }

    return d.name || d.description || d.variantName;
  };

  return (
    <Controller
      defaultValue={defaultValue}
      control={form.control}
      name={field}
      render={({ onChange, onBlur, name, value }) => {
        return (
          <Select
            className={props.readOnly ? "readOnly" : undefined}
            labelInValue={labelInValue}
            onDropdownVisibleChange={(isOpen) => {
              if (isOpen) actions.fetch({ ...api.params });
            }}
            style={{ width: "100%" }}
            name={name}
            allowClear={true}
            value={
              Array.isArray(value)
                ? value.map((m) => (objectInValue ? m?.id : m))
                : value?.id || value
            }
            onBlur={onBlur}
            onChange={(value) => {
              if (type === "multiple") {
                if (objectInValue) {
                  let values = [];
                  value.forEach((val) => {
                    values.push(data.find((f) => f.id == val));
                  });
                  onChange(values);
                } else {
                  onChange(value);
                }
              } else {
                value = data.find((f) => f.id == value);
                onChange(objectInValue ? value : value?.id);
              }
            }}
            showAction="focus"
            onSelect={(item) => {
              let selectedValues = form.getValues(field);
              selectedValues = Array.isArray(selectedValues)
                ? selectedValues
                : [selectedValues];
              if (_excludedOptions.includes(item)) {
                form.setValue(
                  field,
                  selectedValues.filter((i) => i != item)
                );
                message.warning("Bu seçenek başka bir satırda seçilmiş.");
              }
            }}
            showSearch
            mode={type || ""}
            optionFilterProp="label"
            disabled={
              (props.hasOwnProperty("dependent") && !props.dependent) ||
              props.disabled
            }
            loading={store.process === ACTION_TYPES.FETCHING_DATA}
            placeholder={placeholder}
            dropdownRender={(menu) => (
              <div>
                {type === "multiple" ? (
                  <div>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        size="small"
                        style={{ marginRight: 8 }}
                        onClick={() => {
                          form.setValue(
                            field,
                            data
                              .filter(
                                (f) =>
                                  !_excludedOptions.some(
                                    (s) => s === f.id || s === f
                                  )
                              )
                              .map((m) => (objectInValue ? m : m?.id))
                          );
                        }}
                      >
                        Tümünü Seç
                      </Button>
                      <Button
                        size="small"
                        style={{ marginRight: 8 }}
                        onClick={() => {
                          form.setValue(field, []);
                        }}
                      >
                        Temizle
                      </Button>
                    </div>
                    <Divider style={{ margin: "4px 0" }} />
                    {menu}
                  </div>
                ) : (
                  menu
                )}
              </div>
            )}
          >
            {data?.map((d) => {
              return (
                <Select.Option
                  key={d.id}
                  value={d.id}
                  label={generateOptionLabel(d)}
                  disabled={disabledOptions?.find((item) => item?.id === d?.id)}
                >
                  {generateOptionLabel(d)}
                </Select.Option>
              );
            })}
          </Select>
        );
      }}
    />
  );
}
